import { render, staticRenderFns } from "./HandleVisualizzaPESATE.vue?vue&type=template&id=54e5428c"
import script from "./HandleVisualizzaPESATE.vue?vue&type=script&lang=js"
export * from "./HandleVisualizzaPESATE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports